import { Typography } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';

import { onPrimaryColor } from '@/styles/darkHero.ts';

interface Props {
    step: number;
    title: string;
}

const useStyles = makeStyles((theme: any) => ({
    container: {
        display: 'flex',
        alignItems: 'center',
        gap: '0.75rem',
    },
    stepNumber: {
        flex: 'none',
        width: '1.625rem',
        height: '1.625rem',
        borderRadius: '50%',
        backgroundColor: theme.palette.common.yellow,
        color: onPrimaryColor(theme),
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        fontSize: '0.8125rem',
        fontWeight: theme.weight.heading,
    },
    title: {
        ...theme.typography.body1,
        fontWeight: theme.weight.heading,
        color: theme.palette.common.darkGrey,
        margin: 0,
    },
}));

export const SearchStepHeader = ({ step, title }: Props) => {
    const classes = useStyles();
    return (
        <div className={classes.container}>
            <span className={classes.stepNumber}>{step}</span>
            <Typography className={classes.title} component="h2">
                {title}
            </Typography>
        </div>
    );
};
